// extracted by mini-css-extract-plugin
module.exports = {"loader":"Loader_loader__lzqSF","pulse":"Loader_pulse__1V-uZ"};